import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import MemberVerificationPopup from './MemberVerification'



const Transactions = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const baseUrl = process.env.REACT_APP_API;


  const invoiceId = "8kBQC2uXDJzjsvc8gfNcX5aEPWHw44jPK"; 
  const [memberCode, setmemberCode] = useState(null);
  const [isVerified, setIsVerified] = useState({
  email: false,
  wallet: false
});

  useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        if (!token) {
          navigate('/token/signin');
          return;
        }
      
        const validateToken = async () => {
          try {
            const response = await fetch(`${baseUrl}/validate-token`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ token }),
            });
      
            const data = await response.json();
      
            if (!data.valid) {
              sessionStorage.removeItem('authToken'); // Optional cleanup
              navigate('/token/signin');
            }
          } catch (error) {
            console.error('Token validation failed:', error);
            sessionStorage.removeItem('authToken');
            navigate('/token/signin');
          }
        };
      
        validateToken();
      }, [navigate]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        setmemberCode(decoded.memberCode );
      } catch (error) {
        console.error("Invalid token", error);
      }
    }
  }, []);

  // Fetch transactions data from the API
  useEffect(() => {

    const fetchTransactions = async () => {
      if (!memberCode) return;
      setLoading(true);
      const token = sessionStorage.getItem("authToken");
      try {
        const response = await axios.get(`${baseUrl}/api/transaction/${memberCode}`, {
             headers: {
            'Content-Type': 'application/json',
             Authorization: `Bearer ${token}`,
            },
          data: {
            invoice_id: invoiceId,
          },
        });

        if (response.data && response.data.transactions) {
          setTransactions(response.data.transactions.reverse());
        }
    } catch (error) {
        console.error('Error fetching transactions:', error);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchTransactions();
}, [memberCode, invoiceId]); 

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Paginated data
  const indexOfLastTransaction = currentPage * itemsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - itemsPerPage;
  const currentTransactions = transactions.slice(indexOfFirstTransaction, indexOfLastTransaction);


  const getSerialNumber = (index) => index + indexOfFirstTransaction + 1;
  if (loading) {
    return (
      <div className="loader-wrapper">
        <Loader />
      </div>
    );
  }

  const handleVerificationChange = (verificationData) => {
  setIsVerified({
    email: verificationData.IsEmailVerified === 1,
    wallet: !!verificationData.PhantomSolanaAddress
  });
};

  return (

    <>
       <MemberVerificationPopup 
      memberCode={memberCode} 
      onVerificationChange={handleVerificationChange} 
    />
      <div
        style={{
          backgroundImage: `url(/images/main-background.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1,
          filter: 'blur(10px)',
        }}
      ></div>
    <div className="transactions-wrapper">
    <div className="transactions-container">
        <h6>
        <strong>Transaction Summary</strong>
        </h6>

        {/* Conditional rendering based on transaction availability */}
        {transactions.length === 0 ? (
        <div className="no-transactions-message">
            <p>No Transaction Summary</p>
        </div>
        ) : (
        <>
            {/* Table to display transactions */}
            <div className="table-container">
            <table className="table">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Invoice ID</th>
                    <th>Amount (USDT)</th>
                    <th>Currency Amount</th>
                    <th>Currency</th>
                    <th>RZTO Amount</th>
                    <th>Status</th>
                    <th>Time</th>
                </tr>
                </thead>
                <tbody>
                {currentTransactions.map((transaction, index) => (
                    <tr key={transaction.invoice_id}>
                    <td>{getSerialNumber(index)}</td>
                    <td>{transaction.invoice_id}</td>
                    <td>{transaction.Amount}</td>
                    <td>{transaction?.CurrenceyAmount || 'N/A'}</td>
                    <td>{transaction?.Currency?.toUpperCase() || 'N/A'}</td>
                    <td>{transaction.RizzAmount}</td>
                    <td>{transaction.Status}</td>
                    <td>{new Date(transaction.CreatedAt).toLocaleString()}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination">
            <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Previous
            </button>
            <span>Page {currentPage}</span>
            <button
                disabled={currentPage === Math.ceil(transactions.length / itemsPerPage)}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </button>
            </div>
        </>
        )}
    </div>
    </div>
    </>
  );
};

export default Transactions;
